import { render, staticRenderFns } from "./session-rates-report.vue?vue&type=template&id=c6827360"
import script from "./session-rates-report.vue?vue&type=script&lang=js"
export * from "./session-rates-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports